exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-list {\n  position: absolute;\n  margin: 0;\n  width: 100%;\n  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n}\n.item-list ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.slide-left-enter,\n.slide-right-leave-to {\n  opacity: 0;\n  transform: translate(30px, 0);\n}\n.slide-left-leave-to,\n.slide-right-enter {\n  opacity: 0;\n  transform: translate(-30px, 0);\n}\n.item-move,\n.item-enter-active,\n.item-leave-active {\n  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n}\n.item-enter {\n  opacity: 0;\n  transform: translate(30px, 0);\n}\n.item-leave-active {\n  position: absolute;\n  opacity: 0;\n  transform: translate(30px, 0);\n}\n@media (max-width: 600px) {\n.item-list {\n    margin: 0;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/views/GridContainer.vue?vue&type=style&index=0&id=14ba1291&lang=stylus&
// module id = 521
// module chunks = 1 2